
export const LOAD_TOOLTIP_DATA_IN_PROGRESS = "LOAD_TOOLTIP_DATA_IN_PROGRESS";
export const loadToolTipDataInProgress = () => ({
  type: LOAD_TOOLTIP_DATA_IN_PROGRESS,
});

export const LOAD_TOOLTIP_DATA_SUCCESS = "LOAD_TOOLTIP_DATA_SUCCESS";
export const loadToolTipDataSuccess = (data) => ({
  type: LOAD_TOOLTIP_DATA_SUCCESS,
  payload: { data },
});

export const LOAD_TOOLTIP_DATA_FAILURE = "LOAD_TOOLTIP_DATA_FAILURE";
export const loadToolTipDataFailure = () => ({
  type: LOAD_TOOLTIP_DATA_FAILURE,
});

export const TOOLTIP_OPERATION_COMPLETED = "TOOLTIP_OPERATION_COMPLETED";
export const toolTipOperationCompleted = () => ({
  type: TOOLTIP_OPERATION_COMPLETED,
});


export const OPEN_TOOLTIP_DIALOG = "OPEN_TOOLTIP_DIALOG";
export const openTooltipDialog = () => ({
  type: OPEN_TOOLTIP_DIALOG,
});

export const CLOSE_TOOLTIP_DIALOG = "CLOSE_TOOLTIP_DIALOG";
export const closeTooltipDialog = () => ({
  type: CLOSE_TOOLTIP_DIALOG,
});

export const LOAD_LAST_EVENT_ID = "LOAD_LAST_EVENT_ID";
export const loadLastEventId = (data) => ({
  type: LOAD_LAST_EVENT_ID,
  payload: { data },
});


export const LOAD_EVENT_TOOLTIP_DATA = "LOAD_EVENT_TOOLTIP_DATA";
export const loadEventTooltipData = (data) => ({
  type: LOAD_EVENT_TOOLTIP_DATA,
  payload: { data },
});


export const CLEAR_EDIT_DATA = "CLEAR_EDIT_DATA";
export const clearEditData = () => ({
  type: CLEAR_EDIT_DATA,
});


